import React from 'react'
import { connect } from 'react-redux'
import SectionItemContainer from '../../Layout/SectionItemContainer/SectionItemContainer'
import {
    removeAnswer,
    removeQuestion,
    setQuestionStatus,
    updateAnswerList,
} from '@/app/redux/actions/activity-creation'
import { Question as IQuestion } from '@/app/models/new-activity-creation-state'
import CommunicationTaskAction from './CommunicationTaskAction'
import './Action.scss'

const Action = (props) => {
    const {
        questionList,
        setQuestionStatus,
        updateAnswerList,
        removeQuestion,
        removeAnswer,
        section,
        disableSurveys,
        onSave,
        onAction,
    } = props

    const componentClass = 'smart-new-activity-action'

    const onAddQuestion = (questionLength: number, question: Partial<IQuestion>) => {
        setQuestionStatus(questionLength, question)
        onAction()
    }
    const onUpdateAnswer = (
        questionIndex: number,
        answerIndex: number,
        answer: string,
        disabled: boolean
    ) => {
        updateAnswerList(questionIndex, answerIndex, answer, disabled)
    }
    const onRemoveAnswer = (index: number, answerIndex: number) => {
        removeAnswer(index, answerIndex)
    }
    const onQuestionSave = (index: number, question: Partial<IQuestion>) => {
        setQuestionStatus(index, question)
        onSave()
    }
    const onQuestionEdit = (index: number, question: Partial<IQuestion>) => {
        setQuestionStatus(index, question)
    }
    const onQuestionRemove = (index: number) => {
        removeQuestion(index)
    }
    const onQuestionReduce = (index: number, question: Partial<IQuestion>) => {
        if (question.isEdit) {
            setQuestionStatus(index, { isEdit: false })
            return
        }
        onQuestionRemove(index)
    }

    return (
        <div className={componentClass}>
            <SectionItemContainer hideFooter={true} onSave={() => props.onSave()}>
                <CommunicationTaskAction
                    questionList={questionList}
                    onAddQuestion={onAddQuestion}
                    onUpdateAnswer={onUpdateAnswer}
                    onRemoveAnswer={onRemoveAnswer}
                    onQuestionSave={onQuestionSave}
                    onQuestionEdit={onQuestionEdit}
                    onQuestionRemove={onQuestionRemove}
                    onQuestionReduce={onQuestionReduce}
                    disableSurveys={disableSurveys}
                    section={section}
                    onSave={onSave}
                    onAction={onAction}
                />
            </SectionItemContainer>
        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => ({
    setQuestionStatus: (index: number, question: Partial<IQuestion>) =>
        dispatch(setQuestionStatus(index, question)),
    removeQuestion: (index: number) => dispatch(removeQuestion(index)),
    updateAnswerList: (questionIndex: number, index: number, value: string, disabled?: boolean) =>
        dispatch(updateAnswerList(questionIndex, index, value, disabled)),
    removeAnswer: (questionIndex: number, answerIndex: number) =>
        dispatch(removeAnswer(questionIndex, answerIndex)),
})

export default connect(() => ({}), mapDispatchToProps)(Action)
